import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

// Connects to data-controller="choices"
export default class extends Controller {
  static targets = [ "control" ]

  connect() {
    this.choices = new Choices(this.controlTarget, {
      duplicateItemsAllowed: false,
      addItems: true,
      addChoices: true,
    });
  }

  disconnect() {
    this.choices.destroy();
  }
}
